import React, { useEffect, useState, Suspense } from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'
import { Table, Avatar, Row, Button } from 'antd'
import { SearchOutlined, EditOutlined, FormOutlined } from '@ant-design/icons'
import '../../css/customer.scss'
import { fetchCustomers2 } from '../../store/action/customer.action'
import TestClinicTag from '../common/testclinic.tag'
import { loginAsCustomer } from '../../store/action/profile.action'
import { formatPhoneNumberIntl } from 'react-phone-number-input'
import { render } from 'react-dom'
import {
  getLast7Activities,
  getLast7Measurements,
  getStats,
} from '../../store/action/patient.action'
import { getCaseStats } from '../../store/action/actioncases.action'
import moment from 'moment'
import { constants } from '../../constants'

const HCCustomerTable = (props) => {
  var history = useHistory()
  const [activityrange, setactivityRange] = useState(365)
  const [customerData, setCustomerData] = useState([])
  useEffect(() => {
    fetchCustomersList(
      { current: 1, pageSize: 20 },
      { order: 'ascend', field: 'surgery' }
    )
  }, [props.company, props.companyid])

  var fetchCustomersList = async (pagination, sorter) => {
    props.fetchCustomers({
      companyid: props.company ? props.company?._id : props.companyid,
      pagination,
      searchText: props.searchText,
    })
  }

  var formatdata = (data) => {
    data && data.forEach((e, i) => (e.key = e._id))
    return data
  }

  var dataSource = formatdata(props.customers)
  var pagination = {
    ...props.pagination,
    showSizeChanger: true,
  }

  var renderName = (name, obj) => {
    return (
      <Row className={'nameRow'}>
        <Avatar src={obj?.logo}>{name ? name[0]?.toUpperCase() : ''}</Avatar>
        <span>{_.upperFirst(name)}</span>
        <TestClinicTag isTest={obj?.istestclinic} />
      </Row>
    )
  }

  var handleRowClick = (record) => {
    props.loginAsCustomer(record)
    history.push('/compliance')
  }

  var handleRow = (record, rowIndex) => {
    return {
      onClick: () => handleRowClick(record),
    }
  }

  var patientclick = (e, obj) => {
    props.loginAsCustomer(obj)
    e.stopPropagation()
  }

  var handleLoginAs = (e, row) => {
    e.stopPropagation()
    history.push('/customers/edit/' + row._id)
  }

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      render: (name, obj) => renderName(name, obj),
    },
    {
      title: 'Access Code',
      dataIndex: 'accesscode',
      render: (name, obj) => name || 'NA',
    },
    {
      title: 'Contact Person',
      dataIndex: 'contact',
      render: (contact) => <>{contact?.name}</>,
    },
    {
      title: 'Contact Info',
      dataIndex: 'contact',
      render: (contact) => (
        <>
          Email: {contact?.email}
          <br />
          Phone: {contact?.phone}
        </>
      ),
    },
    {
      title: 'Active Patients',
      dataIndex: 'patients',
      align: 'center',
      render: (patient, obj) => (
        <Link
          style={{ color: '#1890ff' }}
          onClick={(e) => patientclick(e, obj)}
          to={{ pathname: '/patient', state: { type: 'active' } }}
        >
          <Button type='text' style={{ color: '#1890ff' }}>
            {patient}
          </Button>
        </Link>
      ),
    },
    // {
    //     title: 'Fully Compliant',
    //     dataIndex: 'fullyCompliant',
    //     align: 'center',
    //     render: (patient, obj) => <Link style={{ color: '#008000' }} onClick={(e) => patientclick(e, obj)}
    //         to={{ pathname: '/patient', state: { patientids: patient, name: 'Patient completely followed the exercise schedule' } }}>
    //         <Button type="text" disabled={patient?.length == 0} >
    //             {patient?.length}
    //         </Button>
    //     </Link>
    // },
    // {
    //     title: 'Partially Compliant',
    //     dataIndex: 'partiallyCompliant',
    //     align: 'center',
    //     render: (patient, obj) => <Link style={{ color: '#cccc00' }} onClick={(e) => patientclick(e, obj)}
    //         to={{ pathname: '/patient', state: { patientids: patient, name: 'Patients partially following the exercise schedule' } }}>
    //         <Button type="text" disabled={patient?.length == 0} style={{ color: '#cccc00' }}>
    //             {patient?.length}
    //         </Button>
    //     </Link>
    // },
    // {
    //     title: 'Not Compliant',
    //     dataIndex: 'notCompliant',
    //     align: 'center',
    //     render: (patient, obj) => <Link style={{ color: '#ff0000' }} onClick={(e) => { console.log("df", patient); patientclick(e, obj) }}
    //         to={{ pathname: '/patient', state: { patientids: patient, name: 'Patients not following the exercise schedule' } }}>

    //         <Button type="text" disabled={patient?.length == 0} style={{ color: '#ff0000' }}>
    //             {patient?.length}
    //         </Button>
    //     </Link>,
    // },
    // {
    //     title: 'Inactive last 3 days',
    //     dataIndex: 'last3daysInact',
    //     align: 'center',
    //     render: (patient, obj) => <Link style={{ color: '#ff0000' }} onClick={(e) => patientclick(e, obj)}
    //         to={{ pathname: '/patient', state: { patientids: patient, name: 'Patients not following the exercise schedule' } }}>
    //         <Button type="text" disabled={patient?.length == 0} style={{ color: '#ff0000' }}>
    //             {patient?.length}
    //         </Button>
    //     </Link>,
    // },
    {
      title: 'Open Cases',
      align: 'center',
      dataIndex: 'assigned',
      width: '200px',
      render: (row, obj) => (
        <Link
          style={{ color: '#1890ff' }}
          onClick={(e) => e.stopPropagation()}
          to={{
            pathname: '/cases',
            state: {
              status: 'Assigned',
              customerid: obj.key,
              assigned: obj.assigned,
              unassigned: obj.unassigned,
            },
          }}
        >
          <Button type='text'>{row}</Button>
        </Link>
      ),
    },
  ]

  props.user.role == constants.ROLE.COMPANY_ADMIN &&
    columns.push({
      title: 'Unassigned Cases',
      dataIndex: 'unassigned',
      align: 'center',
      width: '200px',
      render: (row, obj) => (
        <Link
          style={{ color: '#1890ff' }}
          onClick={(e) => e.stopPropagation()}
          to={{
            pathname: '/cases',
            state: {
              status: 'Unassigned',
              assigned: obj.assigned,
              customerid: obj.key,
              unassigned: obj.unassigned,
            },
          }}
        >
          <Button type='text'>{row}</Button>
        </Link>
      ),
    })

  props.user.role == constants.ROLE.COMPANY_ADMIN &&
    columns.push({
      title: 'Action',
      align: 'center',
      width: '200px',
      render: (row, obj) => (
        <Link
          style={{ color: '#1890ff' }}
          onClick={(e) => e.stopPropagation()}
          to={{
            pathname: '/customers/edit/' + obj._id,
            state: { type: 'active', hasCode: obj.accesscode },
          }}
        >
          <Button
            type='text'
            disabled={false}
            icon={<FormOutlined />}
            iconPosition={<end />}
          ></Button>
        </Link>
      ),
    })

  return (
    <>
      <Table
        size={'large'}
        className={'custom-table'}
        columns={columns}
        dataSource={props.customers}
        loading={props.isLoading}
        pagination={pagination}
        onChange={fetchCustomersList}
        bordered={false}
        onRow={handleRow}
      />
    </>
  )
}

HCCustomerTable.propTypes = {
  fetchSurgeon: PropTypes.func.isRequired,
  surgeons: PropTypes.array,
  sorter: PropTypes.object,
  searchText: PropTypes.string,
  pagination: PropTypes.object,
  isLoading: PropTypes.bool,
  selectedSurgeons: PropTypes.array,
  active: PropTypes.bool,
}

const mapStateToProps = (state) => {
  return {
    company: state.profile.company,
    customers: state.customer.customers,
    user: state.profile.user,
    searchText: state.customer.searchText,
    pagination: state.customer.pagination,
    isLoading: state.customer.isLoading,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchCustomers: (params) => dispatch(fetchCustomers2(params)),
    loginAsCustomer: (customer) => dispatch(loginAsCustomer(customer)),
    getLastActivities: (customerid, date) =>
      dispatch(getLast7Activities(customerid, date)),
    getLastMeasurements: (customerid, date) =>
      dispatch(getLast7Measurements(customerid, date)),
    getStats: () => dispatch(getStats()),
    getCaseStats: () => dispatch(getCaseStats()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(HCCustomerTable)
